import { Component } from 'react';

import {
	Carousel
} from '@beisen/chaos-ui';

import * as helper from '../util/helper';

export default class BSCarousel extends Component {
    constructor(props, context) {
        super(props, context);
    }

    onTouchTap(item, evt) {
    	evt.preventDefault();
    	helper.pageJump(item.linkUrl);
    }

    getImageList(datas) {
    	if(datas && datas.length > 0) {
    		return datas.map(item => {
    			return item.cmp_data;
    		});
    	}
    	return [];
    }

    render() {
    	const { sub_cmps } = this.props;
        return <Carousel autoPlay={true} showTitle={true} imageList={this.getImageList(sub_cmps)} onTouchTap={this.onTouchTap.bind(this)} />;
    }
}



// WEBPACK FOOTER //
// ./src/components/Carousel/Carousel.js